import styled from 'styled-components'

const Bodytext = styled.p`
  color: ${({ theme }) => theme.colors.slate};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.57em;
  margin: 0;
`

export default Bodytext
